import { Button } from "../components/ui/index.js";
export interface MonthChangeLogVersion {
  id: number;
  versionNumber: number;
  fileName: string;
  createdByName: string;
  createdAt: string;
  manualChangeCount: number;
}
export function PayrollCloseArtifacts({
  versions: monthChangeLogs,
  loading,
  downloading,
  onOpen,
  onDownload,
}: {
  versions: MonthChangeLogVersion[];
  loading: boolean;
  downloading: boolean;
  onOpen: (id: number) => void;
  onDownload: (id: number) => void;
}) {
  return (
    <section
      aria-label="Month change log versions"
      className="w-full overflow-hidden rounded-xl border border-border bg-background shadow-[0_16px_36px_-28px_rgb(0_0_0_/_0.75)]"
    >
      <div className="flex items-center justify-between border-b border-border bg-elevated/30 px-5 py-4">
        <div>
          <p className="text-sm font-semibold text-foreground">
            Month change log
          </p>
        </div>
        <span className="rounded-full border border-border bg-background px-2.5 py-1 text-xs font-medium text-foreground-muted">
          {monthChangeLogs.length}{" "}
          {monthChangeLogs.length === 1 ? "version" : "versions"}
        </span>
      </div>
      {loading ? (
        <p className="px-3 py-3 text-xs text-foreground-muted">
          Loading published reports…
        </p>
      ) : monthChangeLogs.length ? (
        <ul className="divide-y divide-border">
          {monthChangeLogs.map(
            (log: {
              id: number;
              versionNumber: number;
              fileName: string;
              createdByName: string;
              createdAt: string;
              manualChangeCount: number;
            }) => (
              <li
                key={log.id}
                className="flex flex-wrap items-center justify-between gap-4 px-5 py-4"
              >
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-md border border-accent/30 bg-accent-subtle px-2 py-1 text-xs font-semibold text-link">
                      v{log.versionNumber}
                    </span>
                    <p className="truncate text-sm font-medium text-foreground">
                      {log.fileName}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <Button
                    variant="ghost"
                    size="sm"
                    type="button"
                    onClick={() => onOpen(log.id)}
                    className="pohoda-file-action cursor-pointer rounded-md px-2 text-xs font-medium text-foreground-muted hover:bg-elevated hover:text-foreground"
                  >
                    Open
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    type="button"
                    onClick={() => onDownload(log.id)}
                    disabled={downloading}
                    className="pohoda-file-action cursor-pointer rounded-md border border-border px-2.5 text-xs font-medium text-foreground hover:bg-elevated disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Download
                  </Button>
                </div>
              </li>
            ),
          )}
        </ul>
      ) : (
        <p className="px-3 py-3 text-xs text-foreground-muted">
          No published month change log is available yet.
        </p>
      )}
    </section>
  );
}
